export default __webpack_public_path__ + "static/media/MarkerIconGreen.9d96b4f0.svg";